var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionMedium = function SvgConnectionMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 11.7h2.025a.6.6 0 0 1 .6.6v2.4a.6.6 0 0 1-.6.6H2.3a.6.6 0 0 1-.6-.6v-2.4a.6.6 0 0 1 .6-.6ZM7.925 7.95H9.95a.6.6 0 0 1 .6.6v6.15a.6.6 0 0 1-.6.6H7.925a.6.6 0 0 1-.6-.6V8.55a.6.6 0 0 1 .6-.6ZM12.85 4.05a.7.7 0 0 1 .7-.7h2.025a.7.7 0 0 1 .7.7V14.7a.7.7 0 0 1-.7.7H13.55a.7.7 0 0 1-.7-.7V4.05Zm.8.1V14.6h1.825V4.15H13.65Z",
    fill: "#fff"
  })));
};
export default SvgConnectionMedium;